import { required, digits, alpha, email, max, min, size, numeric, confirmed, excluded, between, min_value, max_value } from "vee-validate/dist/rules";
import {
  extend,
  //validate,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

import i18n from "@/i18n";

setInteractionMode("aggressive");

extend("between", {
  ...between,
  params: ["min"],
  validate(value, { min }) {
    return value >= min;
  },
  message: "{_min_}'den daha büyük bir değer giriniz.",
});

extend("betweenMin", {
  ...between,
  params: ["min"],
  validate(value, { min }) {
    return value >= min;
  },
  message: `{min}'den daha büyük bir değer giriniz.`,
});

extend("betweenMax", {
  ...between,
  params: ["max"],
  validate(value, { max }) {
    return value <= max;
  },
  message: `{max}'den daha küçük bir değer giriniz.`,
});

extend("btw", {
  async validate(value, { min, max }) {
    return Number(min) <= value && Number(max) >= value;
  },
  params: ["min", "max"],
  message: "{_field_} {min} ve {max} arasında bir sayı olmalıdır",
});

extend("btwDate", {
  async validate(value, { min, max }) {
    return new Date(min).getTime() <= new Date(value).getTime() && new Date(max).getTime() >= new Date(value).getTime();
  },
  params: ["min", "max"],
  message: "{_field_} {min} ve {max} arasında olmalıdır",
});

extend("digits", {
  ...digits,
  message: "{_field_} {length} sayıdan oluşmalıdır. ({_value_})",
});

extend("numeric", {
  ...numeric,
  message: "{_field_} sadece sayıdan oluşmalıdır.",
});
extend("justAlphabet", {
  ...alpha,
  message:"{_field_} sadece harften oluşmalıdır."
})

extend("required", {
  ...required,
  params: ["message"],
  // message: "{_field_} " + i18n.t("notEmpty"),
  message: "{_field_} {message}",
});

extend("email", {
  ...email,
  params: ["message"],
  message: "{message}",
});

extend("max", {
  ...max,
  message: "{_field_} {length} karakterden büyük olmalıdır.",
});

extend("min", {
  ...min,
  message: "{_field_} {length} karakterden oluşmalıdır.",
});

extend("size", {
  ...size,
  message: "{_field_} karakterden oluşmalıdır.",
});

extend("confirmed", {
  ...confirmed,
  message: "{_field_} eşit değil",
});

extend("confirm", {
  async validate(value, { target, msg }) {
    return new String(target).valueOf() == new String(value).valueOf() && msg != undefined;
  },
  params: ["target", "msg"],
  message: "{_field_}  {msg}",
});

extend("excluded", {
  ...excluded,
  message: "{_field_} " + i18n.t("notEmpty"),
});

extend("min_value", {
  ...min_value,
  message: "{min}'den büyük bir değer giriniz.",
});

extend("max_value", {
  ...max_value,
  message: "{_field_}'dan küçük bir değer giriniz.",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
};
